<template>

<v-card class="mt-2">
    <v-card-title class="subtitle-1">
        공간정보
        <v-spacer/>
        <v-col cols="auto" class="py-0 pr-0">
            <v-btn color="secondary" @click="create()" class="pl-3">
                <v-icon class="mr-2">{{ mdiImagePlus }}</v-icon> 공간추가
            </v-btn>
            <v-dialog v-if="editItem" v-model="dialog" width="800">
                <v-card>
                    <v-card-title class="subtitle-1">공간등록</v-card-title>
                    <v-card-text>
                        <v-row align="center">
                            <v-col cols="auto" class="subtitle-2 py-0">공간이미지 (사진/전후사진)</v-col>
                            <v-spacer/>
                            <v-col cols="auto" class="py-0">
                                <v-switch v-model="editItem.beforeEnable" hide-details class="mt-0 py-0"></v-switch>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col v-if="editItem.beforeEnable" class="py-0">
                                <v-row align="center">
                                    <v-col cols="auto" class="py-0 pr-0">
                                        <v-img v-if="editItem.beforeImage" :src="createObjectURL(editItem.beforeImage)" width="128" height="128" contain></v-img>
                                        <v-responsive v-else width="128" height="128">
                                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                                <v-icon>mdi-image</v-icon>
                                            </v-row>
                                        </v-responsive>
                                    </v-col>
                                    <v-col>
                                        <v-file-input v-model="editItem.beforeImage" label="Before 이미지" dense show-size accept="image/*"></v-file-input>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col class="py-0">
                                <v-row align="center">
                                    <v-col cols="auto" class="py-0 pr-0">
                                        <v-img v-if="editItem.afterImage" :src="createObjectURL(editItem.afterImage)" width="128" height="128" contain></v-img>
                                        <v-responsive v-else width="128" height="128">
                                            <v-row class="fill-height ma-0 grey lighten-3" align="center" justify="center">
                                                <v-icon>mdi-image</v-icon>
                                            </v-row>
                                        </v-responsive>
                                    </v-col>
                                    <v-col>
                                        <v-file-input v-model="editItem.afterImage" label="After 이미지" dense show-size accept="image/*"></v-file-input>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-select v-model="editItem.type" :items="typeItems" label="공간유형" placeholder=" " dense hide-details class="mt-6"></v-select>

                        <v-row align="center" class="mt-6">
                            <v-col class="pr-0 py-0">
                                <v-text-field v-model="tag" label="태그 입력" placeholder=" " dense hide-details clearable @keydown.enter="editItem.tags.push(tag); tag = null;"></v-text-field>
                            </v-col>
                            <v-col cols="auto" class="py-0">
                                <v-btn color="primary" small @click="editItem.tags.push(tag); tag = null;"><v-icon small class="mr-2">mdi-tag</v-icon>태그추가</v-btn>
                            </v-col>
                            <v-col cols="12" class="pb-0">
                                <v-chip v-for="(tag, index) in editItem.tags" :key="index" small close color="primary" class="mr-1" @click:close="editItem.tags.splice(index, 1)">{{ tag }}</v-chip>
                            </v-col>
                        </v-row>

                        <div class="subtitle-2 mt-4">공간설명</div>
                        <naver-smarteditor v-model="editItem.content" class="mt-2"></naver-smarteditor>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="grey" text @click="cancel()">취소</v-btn>
                        <v-btn color="primary" text @click="insert(editItem)">확인</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-col>
    </v-card-title>
    <v-divider/>
    <v-card-text class="pa-0">
        <v-data-table :items="portfolio.spaces" :headers="headers" disable-pagination disable-sort hide-default-footer>
            <template v-slot:item.image="{ item }">
                <v-img v-if="item.beforeEnable && createObjectURL(item.beforeImage)" :src="createObjectURL(item.beforeImage)" width="96" height="96" class="d-inline-block" contain></v-img>
                <v-img v-if="createObjectURL(item.afterImage)" :src="createObjectURL(item.afterImage)" width="96" height="96" class="d-inline-block" contain></v-img>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="edit(item)">mdi-pencil</v-icon>
                <v-icon small @click="remove(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
    </v-card-text>
</v-card>
</template>

<script>
import { mdiImagePlus } from '@mdi/js';

import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";

export default {
    components: {
        NaverSmarteditor
    },
    props: {
        value: { type: Object, default: null }
    },
    data(){
        return {
            mdiImagePlus,

            portfolio: this.$props.value,

            dialog: false,
            tag: null,

            headers: [
                { text: "이미지", align: "center", width: 220, value: "image" },
                { text: "공간유형", align: "center", width: 100, value: "type" },
                { text: "태그", align: "center", width: 300, value: "tags" },
                { text: "actions", align: "center", width: 100, value: "actions" }
            ],

            index: null,
            editItem: null,
            defaultItem: {
                beforeEnable: false,
                beforeImage: null,
                afterImage: null,
                type: null,
                tags: [],
                content: null
            },

            typeItems: [ "거실", "주방", "욕실", "침실", "드레스룸", "아이방", "현관", "베란다", "기타" ],
        }
    },
    methods: {
        init(){

        },
        create(){
            this.$set(this.$data, "editItem", JSON.parse(JSON.stringify(this.defaultItem)));
            this.index = undefined;
            this.dialog = true;
        },
        edit(space){
            this.editItem = {
                ...space,
                beforeImage: space.beforeImage ? new Blob([ space.beforeImage ]) : null,
                afterImage: space.afterImage ? new Blob([ space.afterImage ]) : null,
                tags: JSON.parse(JSON.stringify(space.tags))
            };

            this.index = this.portfolio.spaces.findIndex((item => item == space));
            this.dialog = true;
        },
        cancel(){
            this.editItem = null;
            this.dialog = false;
        },
        insert(space){
            try{
                if(this.check()){
                    this.$set(this.portfolio.spaces, this.index === undefined ? this.portfolio.spaces.length : this.index, space);
                }
                this.editItem = null;
                this.dialog = false;
            }
            catch(error){
                alert(error.message);
            }
        },
        check(){
            if(!this.editItem.type) throw new Error("공간유형을 선택해주세요");
            if(!this.editItem.beforeEnable && !this.editItem.afterImage) throw new Error("공간이미지를 업로드 해주세요");
            else if(this.editItem.beforeEnable){
                if(!this.editItem.beforeImage) throw new Error("Before 이미지를 업로드 해주세요");
                if(!this.editItem.afterImage) throw new Error("After 이미지를 업로드 해주세요");
            }
            return true;
        },
        remove(space){
            this.portfolio.spaces.splice(this.portfolio.spaces.findIndex(item => item == space), 1);
        },
        createObjectURL(file){
            return file ? URL.createObjectURL(file) : null;
        }
    }
}
</script>